import { USER_ROLES } from "../constants";

const LEGAL_NAME_EDITABLE_COUNTRIES = ["SG"];

/**
 * Legal name edits are offered for SG customers.
 * When admin authorization is enabled, only customer_profile_editor admins
 * whose country groups include that customer can open the editor.
 */
export const canEditCustomerLegalName = ({
  appCountry,
  assignedRoles,
  assignedCountries,
  authorizationEnabled,
}: {
  appCountry?: string | null;
  assignedRoles: string[] | null;
  assignedCountries: string[] | null;
  authorizationEnabled: boolean;
}): boolean => {
  const country = appCountry?.trim().toUpperCase();
  if (!country || !LEGAL_NAME_EDITABLE_COUNTRIES.includes(country)) {
    return false;
  }

  if (!authorizationEnabled) {
    return true;
  }

  return (
    !!assignedRoles?.includes(USER_ROLES.CUSTOMER_PROFILE_EDITOR) &&
    !!assignedCountries?.includes(country)
  );
};
